module.exports = __webpack_public_path__ + "components/flag/static/square/es-ga-5edc027a05e294d3270186f57ed0d792.svg";